// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__PY1UI","topBottomGutter":"Layout_topBottomGutter__2Khem"};